import React, {useContext, useEffect, useState} from "react";
import styles from "./generateBpmnModel/GenerateBpmnModel.module.scss";
import appContext from "../../../context/appContext";
import apiGenerateBpmnModel from "../../../services/api/apiGenerateBpmnModel";
import Bpmn from "../../Componnets/Bpmn/Bpmn";
import Explorer from "./Explorer";
import apiAutoSaveBpmnModel from "../../../services/api/apiAutoSaveBpmnModel";
import http from "../../../services/api/utilities/http";
import Rename from "./conformanceChecking/importBpmnModal/Rename";
import ModalBox from "../../Componnets/ModalBox/ModalBox";
import Button from "../../Componnets/Button/Button";
import Loading from "../../Componnets/Loading";

const GenerateBpmnModel = () => {

  const [filterData, setFilterData] = useState(null);
  const [diagramXML, setDiagramXML] = useState(null);
  const [apiResponse, setApiResponse] = useState(null);
  const [xmlFile, setXmlFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const context = useContext(appContext);

  let analysisId = null;
  if (context.handleUid().id) {
    analysisId = context.handleUid().id;
  } else {
    analysisId = JSON.parse(localStorage.getItem("mapData")).id;
  }

  const token = localStorage.getItem('token');
  const getBpmnModel = () => {
    setApiResponse("pending");
    context.handleApiStatusProcessExplorer("loading")
    apiGenerateBpmnModel.postSingle(analysisId, filterData, token).then(res => {
      setDiagramXML(res.response.data);
      setApiResponse("success");
      context.handleApiStatusProcessExplorer("success")
    })
      .catch(err => {
        console.log(err);
        setApiResponse("error");
        context.handleApiStatusProcessExplorer("error")
      })
  }

  useEffect(() => {
    if (filterData && filterData.variants) {
      getBpmnModel();
    }
  }, [filterData]);

  const handleGetSavedBpmnModelData = () => {
    apiAutoSaveBpmnModel.getSingle(analysisId, token).then(res => {
      const result = res.response.data.data.bpmn_config;
      const data = {
        variants: result.variants || [1],
        filters: result.filters || undefined,
        activeVariants: result.active_variants || [1],
        flow: result.flow?.length ? contextData.flow : undefined,
        metrics: result.metrics?.length ? contextData.metrics : undefined,
        activitySelection: result.advanced_activity_filters?.length ? result.advanced_activity_filters : undefined
      }
      context.handleSaveGenerateBpmnFilters(data);
    })
      .catch(err => {
        console.log(err);
      })
  }

  useEffect(() => {
    handleGetSavedBpmnModelData();
  }, []);

  const handleAutoSaveBpmnModel = () => {
    const data = {
      bpmn_config: {
        variants: filterData.variants,
        filters: filterData.filters,
        active_variants: filterData.active_variants,
        flow: filterData.flow,
        metrics: filterData.metrics,
        advanced_activity_filters: filterData.advanced_activity_filters
      }
    }

    apiAutoSaveBpmnModel.postSingle(analysisId, data).then(res => {

    })
      .catch(err => {
        console.log(err);
      })
  }

  useEffect(() => {
    if (filterData) {
      return () => {
        handleAutoSaveBpmnModel();
      }
    }
  }, [filterData]);

  const contextData = context.handleSaveGenerateBpmnFilters();
  useEffect(() => {
    const data = {
      filters: contextData.filters?.length ? contextData.filters : undefined,
      variants: contextData.variants?.length ? contextData.variants : undefined,
      active_variants: contextData.activeVariants?.length ? contextData.activeVariants : undefined,
      flow: contextData.flow?.length ? contextData.flow : undefined,
      metrics: contextData.metrics?.length ? contextData.metrics : undefined,
      advanced_activity_filters: contextData.activitySelection?.length ? contextData.activitySelection : undefined
    }
    if (Object.keys(contextData).length) {
    // && JSON.stringify(data) !== JSON.stringify(filterData)
      if (data.variants) {
        setFilterData(data);
      }
    }
  }, [contextData]);

  const handleSelectedVariants = (variants) => {
    const selectedVariantsIds = variants && variants.map(item => item.id);
    context.handleSaveGenerateBpmnFilters({
      ...contextData,
      variants: selectedVariantsIds,
      activeVariants: selectedVariantsIds.map(item => 1)
    });
  }

  const getRandomFileName = () => {
    var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
    var random = ("" + Math.random()).substring(2, 8);
    var random_number = timestamp + random;
    return random_number + ".bpmn";
  }

  const handleSaveBpmnFile = (fileName) => {
    var file = new Blob([xmlFile], {type: 'text/plain'});
    const formData = new FormData();
    formData.append(
      'file',
      file,
      getRandomFileName()
    );
    formData.append('name', fileName);
    setIsLoading(true);
    http({
      method: 'put',
      url: `process_mining/bpmn/${context.handleUid().id}`,
      data: formData,
      headers: {Authorization: 'Bearer ' + localStorage.getItem('token')},
    })
      .then(res => {
        setIsLoading(false);
        setShowModal(false);
      })
      .catch(err => {
        setIsLoading(false);
        console.log(err);
      })
  }

  const handleGetXmlForSave = (xml) => {
    setXmlFile(xml);
  }

  return (
    <div className={styles.GenerateBpmnModel} style={{height: "100%"}}>
      {
        apiResponse === "success" &&
          <Bpmn
            diagramXML={diagramXML}
            handleGetXmlForSave={handleGetXmlForSave}
          />
      }
      {
        apiResponse === "pending" &&
          <div className={'col-sm-12 d-flex align-items-center justify-content-center p-0'} style={{height: "100%"}}>
            <Loading />
          </div>
      }
      <div className={styles.variantExplorer}>
        <Explorer
          setVariantIndex={(variants) => handleSelectedVariants(variants)}
          isMenuOpen={true}
        />
      </div>
      <div className={`${styles.saveXml} d-flex align-items-center justify-content-center`}>
        <Button block title={"Save in bpmn models"} onClick={() => setShowModal(!showModal)}/>
      </div>
      <ModalBox
        title={'Save in bpmn'}
        size={'small'}
        showModal={showModal}
        handleTriggerShowModal={() => setShowModal(!showModal)}
      >
        <Rename
          onSave={handleSaveBpmnFile}
          fileName={"BPMN FILE"}
          isLoading={isLoading}
        />
      </ModalBox>
    </div>
  )
}

export default GenerateBpmnModel;
